<section class="main-kpis">
  <div class="kpis-header">
    <h2>{{ dictionary.get('MainKPIs') }}</h2>
    <div class="report-actions">
      <button
        buttonTheme="primary"
        buttonType="regular"
        [loading]="isDownloadingCoveredReport"
        [disabled]="isDownloadingCoveredReport"
        (click)="onDownloadReport('covered')"
      >
        {{ isDownloadingCoveredReport ? dictionary.get('Downloading') : dictionary.get('DownloadCoveredReport') }}
      </button>
      <button
        buttonTheme="primary"
        buttonType="regular"
        [loading]="isDownloadingUncoveredReport"
        [disabled]="isDownloadingUncoveredReport"
        (click)="onDownloadReport('uncovered')"
      >
        {{ isDownloadingUncoveredReport ? dictionary.get('Downloading') : dictionary.get('DownloadUncoveredReport') }}
      </button>
    </div>
  </div>
  <div class="kpis-charts">
    @if (loading()) {
      @for (_ of chartSkeletons; track $index) {
        <div class="chart-wrapper">
          <app-pie
            [data]="targetedFrequencyData()"
            [isLoading]="true"
            [compactLegend]="true"
            [height]="260"
          />
        </div>
      }
    } @else {
      @for (chart of coverageCharts(); track chart.key) {
        <div class="chart-wrapper">
          <app-pie
            [data]="chart.data"
            [isLoading]="false"
            [compactLegend]="true"
            [height]="260"
          />
          <span class="chart-label">{{ chart.data.chartLabel }}</span>
        </div>
      }
      @if (userId()) {
        <div class="chart-wrapper">
          <app-pie
            [data]="targetedFrequencyData()"
            [isLoading]="false"
            [compactLegend]="true"
            [height]="260"
          />
          <span class="chart-label">{{ targetedFrequencyLabel }}</span>
        </div>
      }
    }
  </div>
</section>
